import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/quiz/quiz-availability-stage-intro.svg?data'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Start")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Touching base",
    description: "Just 3 quick questions in this next section to help us learn how and when you’d like others to reach out to you.",
    prev: false,
    "is-vertically-aligned": true,
    "onQuizNavigation:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.QuizService.close()))
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, { onClick: _ctx.navigateNext }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}